<ion-header>
  <app-header
    [isBackgroundWhite]="true"
    [pageTitle]="pageTitle"
    [showBackArrow]="showBackArrow"
    [isTemplateFolder]="true"
  >
  </app-header>
</ion-header>


<ion-content>
  <div class="content-max-width">
    <div class="searchsection">
      <div class="searchinput">
        <input type="search"
               [placeholder]=" '_create_from_template_' | translate"
               #searchBox
               (focusin)="onInputClicked()"
               (keyup.enter)="search(searchBox.value)"
               class="search-input"
        />
        <div *ngIf="searchString" (click)="closeSearch()" class="close-search">
          <ion-icon name="close-circle-outline"></ion-icon>
        </div>
      </div>
      <div (click)="search(searchBox.value)" class="searchicon">
        <ion-icon name="search-outline"></ion-icon>
      </div>
    </div>
    <div class="result-wrapper">
      <h2>{{'_templates_' | translate}}</h2>
      <div *ngIf="templateList.length === 0 && !isTemplateLoading">
        <p class="no-post-available">{{'_no_templates_are_available_' | translate}}.</p>
      </div>
      <div *ngIf="!isTemplateLoading">
        <div *ngFor="let list of templateList">

          <div class="result-list" (click)="onTemplateSelect(list)">
            <div style="display: flex;align-items: center">
              <img
                (load)="onImageload($event)"
                [src]="list.image[0]?.thumbnail"
                class="result-img"
              />
              <div style="margin-left: 14px">
                <span class="result-type" *ngIf="list.type === 'jatak'">JA TAK</span>
                <span class="result-type" *ngIf="list.type === 'post'">{{ '_regular_posts_' | translate }}</span>
                <span class="result-type" *ngIf="list.type === 'competition'">{{ '_competition_' | translate }}</span>
                <span class="result-type"
                      *ngIf="list.type === 'spinning_wheel'">{{ '_spinning_wheel_' | translate }}</span>
                <span class="result-type" *ngIf="list.type === 'scratch_card'">{{ '_scratch_card_' | translate }}</span>
                <div class="result-content">
                  <p class="result-subtitle">{{list.title}}</p>
                </div>
              </div>
            </div>
            <div style="width: 24px">
              <ion-icon name="chevron-forward-outline" class="result-right-icon"></ion-icon>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isTemplateLoading">
        <app-template-list-skeleton></app-template-list-skeleton>
      </div>
    </div>
  </div>


  <ion-infinite-scroll (ionInfinite)="loadMore($event)" class="ion-margin-top">
    <ion-infinite-scroll-content>
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>

</ion-content>
